
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 164 138","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.018 2.214v19.49c0 .546 1.215.984 2.71.984 1.498 0 4.353-.44 4.353-.984V8.777a3.164 3.164 0 012.71-2.217h37.05c1.497 0 2.709 2.213 2.709 2.213v12.926c0 .546 2.233.984 3.722.984 1.496 0 2.71-.44 2.71-.984V2.214A3.166 3.166 0 00107.272 0H56.716a3.157 3.157 0 00-2.698 2.214z","fill":"#fff"}}),_c('path',{attrs:{"d":"M146.119 138H17.879a17.877 17.877 0 01-12.636-5.255A17.964 17.964 0 010 120.078V35.406A17.965 17.965 0 015.242 22.74a17.88 17.88 0 0112.638-5.256h128.239a17.88 17.88 0 0112.637 5.256A17.965 17.965 0 01164 35.407v84.671a17.963 17.963 0 01-5.244 12.667A17.877 17.877 0 01146.119 138zM17.879 23.762a11.616 11.616 0 00-8.21 3.415 11.671 11.671 0 00-3.406 8.23v84.671a11.672 11.672 0 003.406 8.23 11.618 11.618 0 008.21 3.414h128.24a11.619 11.619 0 008.21-3.414 11.669 11.669 0 003.406-8.23V35.406a11.668 11.668 0 00-3.406-8.23 11.617 11.617 0 00-8.21-3.414H17.879z","fill":"#fff"}}),_c('path',{attrs:{"d":"M86.747 67.445h-9.496c-3.22 0-5.831 2.617-5.831 5.845v.767c0 3.228 2.61 5.845 5.831 5.845h9.496c3.22 0 5.832-2.617 5.832-5.845v-.767c0-3.229-2.611-5.845-5.832-5.845z","fill":"#fff"}}),_c('path',{attrs:{"d":"M146.119 76.812H17.879C8.182 76.812 0 67.804 0 62.146h6.265c0 1.753 4.94 8.388 11.616 8.388H146.12c6.675 0 11.616-6.635 11.616-8.389H164c0 5.659-8.182 14.667-17.881 14.667z","fill":"#fff"}})])
          )
        }
      }
    